import styled, { StyledComponent } from 'styled-components';
import { Collapse, Tooltip } from 'antd';

export const StyledSettingWrapper: StyledComponent<'div', any> = styled.div`
  display: flex;
  gap: 8px;
`;

export const StyledSettingTitle: StyledComponent<'div', any> = styled.div`
  display: flex;
  gap: 8px;
  width: 75px;
  padding-top: 4px;
`;

export const EventWrapper: StyledComponent<'div', any> = styled.div`
  margin-bottom: 6px;
  border-radius: 4px;
  border: solid 1px #d9d9d9;
  background: #f5f5f5;
  overflow: hidden;
`;

export const CollapsedEventNameWrapper: StyledComponent<'div', any> = styled.div`
  display: flex;
  padding: 8px 2px 8px 8px;

  justify-content: space-between;
  height: 40px;
  align-items: center;
  cursor: pointer;
  &:hover {
    background: #f2f6ff;
    .event-item-actions {
      display: flex;
    }
  }
`;

export const EventItemActionsWrapper: StyledComponent<'div', any> = styled.div`
  display: none;

  align-items: center;
  height: 100%;
`;

export const EventKeyWrapper: StyledComponent<'div', any> = styled.div`
  display: flex;
  background: #f5f5f5;
  width: 100%;
  padding: 8px 0 0 0;
  @media (min-width: 600px) {
    .event-left {
      min-width: 34%;
    }
  }
`;

export const EventLeftWrapper: StyledComponent<'div', any> = styled.div`
  min-width: 150px;
  text-align: left;
  white-space: break-spaces;
  max-width: 34%;
  display: flex;
`;

export const EventRightWrapper: StyledComponent<'div', any> = styled.div`
  flex: 1;
  text-align: left;
  padding-left: 30px;
  overflow: hidden;
`;

export const ANDText: StyledComponent<'div', any> = styled.div`
  margin: 0 16px;
  color: rgb(0, 0, 0, 0.45);
  text-align: left;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  padding: 0 8px;
  height: 20px;
  border-radius: 10px;
  background-color: #d9d9d9;
`;
interface RuleTextProps {
  width: string;
}

export const RuleText: StyledComponent<'div', any, RuleTextProps> = styled.div<RuleTextProps>`
  width: ${(props) => props.width};
  text-align: left;
  overflow-wrap: break-word;
`;

export const CollapseTitle: StyledComponent<'div', any, { disabled?: boolean }> = styled.div<{
  disabled?: boolean;
}>`
  display: flex;
  align-items: center;
  gap: 16px;
  color: rgba(0, 0, 0, 0.88);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 125% */
  opacity: ${({ disabled }) => (disabled ? '0.4' : '1')};
`;

export const FlowNameWrapper: StyledComponent<'div', any> = styled.div`
  width: 100%;
  padding: 16px 0px 4px 24px;
  border-bottom: 1px solid #d9d9d9;
  label {
    font-weight: 500;
    padding-left: 18px;
    font-size: 16px !important;
    width: 145px;
  }
`;

export const CustomCollapse = styled(Collapse)`
  & .emp-ant-collapse-header {
    padding: 17px 8px 14px 24px !important;
  }
  & .emp-ant-collapse-content {
    padding-right: 24px !important;
    .emp-ant-form-item-label {
      padding-left: 18px;
    }
    .emp-ant-collapse-content-box {
      padding-top: 0 !important;
    }
  }
`;

export const EditingTagWrapper = styled.div`
  color: #fff;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px; /* 127.273% */
  display: flex;
  padding: 3px 4px;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border-radius: 2px;
  border: 1px solid #fa8c16;
  background: #fa8c16;
`;

export const LabelWrapper: StyledComponent<'div', any> = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Dot: StyledComponent<'span', any, {}, never> = styled.span`
  display: inline-flex;
  width: 5px;
  height: 5px;
  background-color: currentColor;
  border-radius: 50%;
`;

export const StyledFlowName = styled(Tooltip)<{ required?: boolean }>`
  line-height: 20px;
  letter-spacing: -0.14px;
  font-weight: 400;

  ${({ required = false }) => {
    if (required) {
      return css`
        &:after {
          content: '*';
          color: #ff4d4f;
        }
      `;
    }
    return;
  }}
`;

export const StyledStartIcon = styled.div`
  &::after {
    content: '*';
    color: #ff4d4f;
  }
`;
export const StyledPoor = styled.div`
  margin-right: -5px;
  &::after {
    content: 'Poor';
    color: #ff4d4f;
    font-weight: 500;
  }
`;
export const StyledExcellent = styled.div`
  margin-right: -4px;
  &:after {
    content: 'Good';
    color: #52c41a;
    font-weight: 500;
  }
`;

export const StyledFair = styled.div`
  padding: 0px 17px;
  &:after {
    content: 'Fair';
    color: #fa8c16;
    font-weight: 500;
  }
`;

export const FairLine = styled.div`
  width: 12px;
  height: 1px;
  background: rgba(0, 0, 0, 0.65);
`;

export const StyleDotWrapper = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledDot = styled.div`
  width: 5px;
  height: 5px;
  background-color: rgba(0, 0, 0, 0.65);
  border-radius: 100%;
`;

export const StyledList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
  margin-left: 10px;
  width: fit-content;
`;

export const StyledListItemWrapper = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  width: fit-content;
`;

export const StyledListItem: StyledComponent<'span', any, { checked?: boolean }> = styled.span<{
  checked?: boolean;
}>`
  color: rgba(0, 0, 0, 0.88);
  font-family: Roboto, sans-serif;
  font-size: 14px;
  line-height: 20px; /* 142.857% */
  letter-spacing: -0.14px;
  opacity: ${(props) => (props.checked ? 1 : 0.4)};
`;

export const StyledIconWrapper = styled.span`
  border-radius: 3px;
  border: 1px solid rgb(255, 255, 255);
  background: rgba(0, 0, 0, 0.04);
  color: rgba(0, 0, 0, 0.45);
  padding: 2px 4px;
`;

export const ViewModeWrapper = styled.div`
  color: #1f1f1f;
  height: 30px;
  font-family: 'Roboto';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: -0.14px;
  padding: 4px 8px 4px 6px;
  gap: 8px;
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.04);
`;

export const ThresholdTitle = styled.div`
  display: inline-flex;
  flex-direction: column;
  margin-left: 40px;
  svg {
    width: 112px;
    height: 71px;
  }
`;

export const ThresholdItem = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  & > span {
    height: 32px;
    line-height: 32px;
  }
`;
export const StyledLabel = styled.div`
  display: flex;
  align-items: flex-start;
  color: rgba(0, 0, 0, 0.88);
  /* Base/14 Strong */
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  flex-direction: column;
`;

export const DescriptionWrapper = styled.div`
  padding-left: 26px;
  .section-title {
    color: rgba(0, 0, 0, 0.88);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    margin-bottom: 8px;
  }
  > div:not(.section-title) {
    margin-bottom: 16px;
  }
  > div:last-child {
    margin-bottom: 0;
  }
`;
